import { apiSend, apiSendJson } from "@/api/apicommon";

export default {
    async getLuData() {
        const method = "GET";
        const endpoint = "/lu/data";
        return apiSend(method, endpoint);
    },
    async getLuPackagings(expressionId: string) {
        const method = "POST";
        const endpoint = "/lu/getLuPackagings/";
        const json = {
            "expressionId": expressionId            
        };
        return apiSendJson(method, endpoint, json)
    }
};
